import { render } from "./ErrorIcon.vue?vue&type=template&id=5f24b393"
const script = {}

import exportComponent from "/home/cretzler/source/Contributr-v2/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__